import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-white.png'
import _imports_1 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-40de0140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "header-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "首页", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "招标采购", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "政府采购", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "寻源快采", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "行业资讯", -1))
const _hoisted_9 = { class: "header-right" }

import { onMounted } from "vue";
import { LinkNode } from "./link-node";
import { useUserStore } from "@/store/modules/user/index";
import { useRouter, useRoute } from "vue-router";
import { logout } from "@/utils/page-tab-util";
import { useRouteHopping } from "@/utils/use-route-to";


export default /*#__PURE__*/_defineComponent({
  __name: 'app-header',
  props: {
    type: null
  },
  setup(__props: any) {

const userStore = useUserStore();
const loginUrl = `${
  process.env.VUE_APP_DOMAIN
}/sso-cross-api/router/relogin/yzczb?url=${encodeURIComponent(
  window.location.href
)}`;
const regUrl = `${process.env.VUE_APP_LOGIN_DOMANI}/homeweb/#/register`;
const router = useRouter();
const route = useRoute();



const registerHandle = () => {
  window.location.href = regUrl;
};
const logOutHandle = async () => {
  userStore.userName = undefined;
  userStore.subjectName = undefined;
  userStore.userRole = [];
  logout();
};
const changeTab = (activeKey: string) => {
  userStore.setMenuKey(activeKey);
};

const runHomePage = () => {
  useRouteHopping("/");
  userStore.setMenuKey("/");
};

onMounted(async () => {
  await router.isReady();
  userStore.setMenuKey(route.fullPath?.split("&bType")[0]);
});

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-container", {
        'header-container-dark': __props.type === 'home',
        'header-container-light': __props.type !== 'home',
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.type == 'home')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              onClick: runHomePage,
              src: _imports_0
            }))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              onClick: runHomePage,
              src: _imports_1,
              alt: "logo"
            }))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_tabs, {
          activeKey: _unref(userStore).menuKey,
          onChange: _cache[0] || (_cache[0] = (activeKey) => changeTab(activeKey))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, { key: "/" }, {
              tab: _withCtx(() => [
                _hoisted_4,
                _createVNode(_unref(LinkNode), { path: "/" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "/site-search?pType=1",
              "force-render": ""
            }, {
              tab: _withCtx(() => [
                _hoisted_5,
                _createVNode(_unref(LinkNode), { path: "/site-search?pType=1" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, { key: "/site-search?pType=2" }, {
              tab: _withCtx(() => [
                _hoisted_6,
                _createVNode(_unref(LinkNode), { path: "/site-search?pType=2" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, { key: "/site-search?pType=3" }, {
              tab: _withCtx(() => [
                _hoisted_7,
                _createVNode(_unref(LinkNode), { path: "/site-search?pType=3" })
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, { key: "/contact-us" }, {
              tab: _withCtx(() => [
                _hoisted_8,
                _createVNode(_unref(LinkNode), { path: "/site-info" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_space, {
          align: "center",
          size: 12
        }, {
          default: _withCtx(() => [
            (!_unref(userStore).userName)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  class: "btn",
                  href: loginUrl
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 登录 ")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  class: "btn2",
                  onClick: _cache[1] || (_cache[1] = () => logOutHandle())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 退出登录 ")
                  ]),
                  _: 1
                })),
            (!_unref(userStore).userName)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 2,
                  onClick: _cache[2] || (_cache[2] = () => registerHandle()),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 免费注册体验 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}
}

})